import { render, staticRenderFns } from "./AdicionarLinkUtilDialog.vue?vue&type=template&id=3b147384&"
import script from "./AdicionarLinkUtilDialog.vue?vue&type=script&lang=js&"
export * from "./AdicionarLinkUtilDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports